export default "__VITE_ASSET__8ed0f778__"